import { RadioIEnumValue } from "./ienumvalue";

/**
 * checboxgroup类型
 */
export class RadioValue implements RadioIEnumValue{

    getEnumValueName():string{
        return this.name;
    }

    getEnumValue():any{
        return this.value;
    }
    
    /**
     * 文本显示
     */
    name:string;

    /**
     * 值显示
     */
    value:string;
}